<div>
    <div class="modal-body">
        <div class="otp-title">{{ 'otpBox.label' | translate }}</div>
        <h4>{{ 'otpBox.message' | translate }} {{ maskedEmailAddress }}</h4><br/>
        <div>
            <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
        </div>
        <div class="center otp-subtitle" *ngIf="showOtpError">
            <small class="error-message">{{ 'otpBox.errorMessage' | translate }}</small>
        </div>
        <ng-container *ngIf="!hideTimer">
            <div class="mt-4">
                <div class="content d-flex justify-content-center align-items-center">
                    <span>{{ 'otpBox.resendQuestion' | translate }}</span>
                </div>

                <div *ngIf="this.timeLeft > 0" disabled
                     class="content d-flex justify-content-center align-items-center resend-disabled">
                    <a class="text-decoration-none ms-3">
                        {{ 'otpBox.resend' | translate }} ({{ timeLeft }})</a>
                </div>
                <div *ngIf="this.timeLeft === 0"
                     class="content d-flex justify-content-center align-items-center resend-enabled">
                    <a href="javascript:;" (click)="resendOtp()" class="text-decoration-none ms-3">
                        {{ 'otpBox.resend' | translate }}</a>
                </div>
                <br/><br/>
                <button class="new-btn btn-primary btn" [ngClass]="{'continue-disabled' : this.otp.length !== 6}"
                        [disabled]="this.otp.length !== 6"
                        (click)="verifyOtp()">
                    {{ 'claimSection.generalLabels.generalButtonLabels.continue' | translate }}
                </button>
            </div>
        </ng-container>
        <br/><br/>
    </div>
</div>

<ng-template #modal_info let-c="close" let-d="dismiss">
    <div class="modal-body">
        <div class="modal-title"><h4>{{ infoMessage | translate }}</h4></div>
        <span *ngIf="subInfoMessage"><br/><p>{{ subInfoMessage | translate }}</p></span>
    </div>
    <div class="mt-4">
        <button class="new-btn btn-primary btn" (click)="c('Close click')">
            {{ 'claimSection.generalLabels.generalButtonLabels.ok' | translate }}
        </button>
        <br/><br/>
    </div>
</ng-template>